import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-20edeef0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"background-color":"#fff"} }
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "main-content pt30 pb100" }
const _hoisted_5 = ["innerHTML"]

import { ref } from 'vue'
import checkPc from '@/utils/checkPc'
import { singlePageApi } from '@/api/common'

/**
 * 判断是否PC端
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const isPC = checkPc()

// 定义变量
const banner = ref('')
const bannerM = ref('')
const mainContent = ref('')

// 获取单页内容
const getSinglePage = async () => {
  const res:any = await singlePageApi({id: 1})
  // console.log(res)
  banner.value = res.pic
  bannerM.value = res.pic_m
  mainContent.value = res.content
}

getSinglePage()


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(isPC))
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          class: "banner",
          src: banner.value || require('@/assets/about/banner.png'),
          alt: ""
        }, null, 8, _hoisted_2))
      : (_openBlock(), _createElementBlock("img", {
          key: 1,
          class: "banner banner-m",
          src: bannerM.value || require('@/assets/about/banner_m.png'),
          alt: ""
        }, null, 8, _hoisted_3)),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", {
        class: "main-content-box",
        innerHTML: mainContent.value
      }, null, 8, _hoisted_5)
    ])
  ]))
}
}

})